export const all = ['offerDetail'] as const
export const detail = (offerId: string, region: string, accommodationPropertyId?: string, offerType?: string, checkIn?: string, checkOut?: string, occupancies?: string, flexibleMonths?: string, flexibleNights?: string, orderId?: string) =>
  [...all, offerId, region, accommodationPropertyId, offerType, checkIn, checkOut, occupancies, flexibleMonths, flexibleNights, orderId] as const
export const reviews = (offerId: string, region: string) =>
  [...all, 'reviews', offerId, region] as const
